<template>
    <modal
        :show="showModal"
        :title="modalTitle"
        size="large"
        :needFooter="true"
        :needHeader="true"
        :centered="true"
        :closeBtn="true"
        class="modal-deed-owner-holder-detail"
        bodyClass="pb-sm-0"
        @close="onCloseModal({directAction: true})">

        <div class="row deed-owner-holder-panel">
            <div class="col-12">
                <DeedOwnerHolderForm
                    v-if="showModal"
                    v-model="form"
                    :panelCfg="panel"
                    :parentId="idPanel"
                    :vScope="vScope"
                    :additional="additional"
                    :baseTranslateID="translateID"
                    :readonlyForm="readonlyFormItem"
                    :start_types="start_types"
                    :end_types="end_types"
                    :genders="genders"
                    :religions="religions"
                    :causes_death="causes_death"
                />
            </div>
        </div>

        <template v-slot:modal-footer>
            <div class="modal-footer border-0 p-2">
                <div class="row w-100 m-0 no-gutters">
                    <div class="col-12">
                        <div class="row d-flex justify-content-center">
                            <div
                                v-for="(btn) in activeButtons"
                                :key="`btn-${idPanel}-${btn.id}`"
                                class="col-12 col-lg-3 pb-2 pb-sm-0"
                                :class="[{'col-sm-6': activeButtons.length==2}, btn.divClass]">
                                <button
                                    class="btn btn-rounded btn-md btn-responsive btn-block min-w-auto"
                                    :class="btn.class"
                                    type="button"
                                    @click.prevent="btn.fn">
                                    {{ $t(btn.name) }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </Modal>
</template>

<script>
import { isFunction } from '@config/utils';
import { EVENTS } from '../../shared/config/event-constants';
import PanelComponentMixin from './mixins/PanelComponentMixin';


let lists = {
    loaded: false,
    start_types: [],
    end_types: [],
    genders: [],
    religions: [],
    causes_death: [],
};

function initialState (){
    return {
        idPanel: 'deed_owner_holder',
        translateID: 'deed_owner_holders',
        form: {
            occupation_deed_owner_id: null,
            deed_owner_holder_start_type_id: null,
            deed_owner_holder_start_at: null,
            deed_owner_holder_end_type_id: null,
            deed_owner_holder_end_at: null,
            entity_id: null,
            entity: {
                id: null,
                name: null,
                phone: null,
                email: null,
                address: null,
                postal_code: null,
                locality: null,
                birth_at: null,
                death_at: null,
                gender_id: null,
                religion_type_id: null,
                cause_death_type_id: null,
                birthplace_id: null,
                biography: null,
                occupation: null,
                father_affiliation: null,
                mother_affiliation: null,
                use_personal_data: false,
                tax_number: null,
                picture: null,
                obs: null,
                status: true,
                age: null,
            }
        },
        excludeFromSave: [
            'deed_owner_holder_start_type',
            'deed_owner_holder_end_type',
            'entity.age',
            'entity.gender',
            'entity.religion_type',
            'entity.cause_death_type',
            'files.*.path',
        ],
        callback: null,
        fnSave: null,
    }
}

export default {
    mixins: [
        PanelComponentMixin,
    ],
    components: {
        Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
        DeedOwnerHolderForm: () => import(/* webpackChunkName: "cemeteries-deedownerholderform" */ './forms/DeedOwnerHolderForm'),
    },
    props: {
        eventShow: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER_HOLDER,
        },
        eventClose: {
            type: String,
            default: EVENTS.CLOSE_MODAL_DETAIL_DEED_OWNER_HOLDER,
        },
        eventClosed: {
            type: String,
            default: EVENTS.CLOSED_MODAL_DETAIL_DEED_OWNER_HOLDER,
        },
    },
    data() {
        return initialState();
    },
    computed: {
        entityName() {
            return this.form?.entity?.name;
        },
        modalTitle() {
            return this.$tc(`${this.translateID}.title_modal`, this.form.id && this.entityName ? 2 : 1, { code: this.entityName })
        },
        start_types() {
            return lists.start_types;
        },
        end_types() {
            return lists.end_types;
        },
        genders() {
            return lists.genders;
        },
        religions() {
            return lists.religions;
        },
        causes_death() {
            return lists.causes_death;
        },
    },
    methods: {
        reset() {
            Object.assign(this.$data, initialState());
        },
        onOpenModal(params = {}) {
            const {data = {}, actions = {}, callback = null, fnSave = null, readonly = false} = params;
            this.reset();

            this.callback = callback;
            this.fnSave = fnSave;

            this.loadLists(data, lists)
            .then(res => {
                if(res) {
                    lists = res;
                    return this.onLoadData(data, actions, readonly);
                }
                return false
            });
        },
    },
}
</script>